module.exports = __webpack_public_path__ + "static/media/ag-products2Long.d16d290a.jpg";